import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

function TranslateText({ text }) {
  const { t } = useTranslation("translate");

  return t(text);
};

TranslateText.propTypes = {
  text: PropTypes.string.isRequired
};

export default TranslateText;
